import React from "react";
import { useTranslation } from "@/translations/TranslationContext";
import aboutempower1 from "@/assets/oussama.jpg";

function BuiltEmpower() {
  const { t } = useTranslation();
  
  return (
    <>
      <div className="builtempower mb150_75">
        <div className="container">
          <div className="row">
            <div className="col-lg-6">
              <img className="mb20" src={aboutempower1} alt="Oussama Hentabli" />
            </div>
            <div className="col-lg-6 builtempowertext">
              <span className="chips">{t.about.story.chips}</span>
              <h2>{t.about.story.title}</h2>
              <p className="text24 mb38" dangerouslySetInnerHTML={{ 
                __html: t.about.story.description.replace('Oussama Hentabli, CPA', '<strong>Oussama Hentabli, CPA</strong>')
              }} />
              <a className="btn btn-secondary" href="/contact">
                {t.about.story.button}
              </a>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default BuiltEmpower;
